import { useQuery } from '@tanstack/react-query';
import { getSession } from '../service';
import { AuthQueryFactory } from '../utils/query-factory';

export function useSession() {
    return useQuery({
        queryKey: AuthQueryFactory.session(),
        queryFn: () => getSession(),
        refetchInterval: 1000 * 60 * 5,
        refetchOnWindowFocus: 'always',
    });
}

export function useSessionOrThrow() {
    const { data, error, isLoading } = useSession();
    if (error || isLoading || data === undefined) {
        throw new Error('No user session');
    }
    return data;
}
